<template>
  <div class="IDcard">
    <van-swipe @change="onChange">
      <van-swipe-item v-for="item in data" :key="item.id">
        <div class="cardPic">
          <div class="zhenjian">
            <div class="leftIcon">
              <img src="../assets/images/canbaoIcon.png" alt="" />
            </div>
            <div class="word">
              <div class="zhenjianName">{{ item.ZZMC }}</div>
              <div class="pingzhen">电子凭证</div>
            </div>
          </div>
          <div class="dibu" v-show="hasCard">
            <div class="left" @click="goView(item)">
              <!-- <img src="../assets/images/dianziIcon.png" alt="" /> -->
              <div class="word">查看电子证照</div>
            </div>
            <div class="right" @click="handleKookCodeClick">
              <div class="word">查看二维码</div>
              <img
                style="
                  height: 14px;
                  width: 14px;
                  margin-left: 5px;
                  vertical-align: middle;
                "
                src="../assets/images/code-icon.png"
                alt=""
              />
            </div>
          </div>
          <div class="dibu" v-show="noCard">
            <div class="word">暂无数据</div>
          </div>
        </div>
      </van-swipe-item>
      <template #indicator>
        <div class="custom-indicator">{{ current + 1 }}/{{ num }}</div>
      </template>
    </van-swipe>
    <van-popup v-model="codeShow" class="my-popup">
      <vue-qr
        :size="191"
        :margin="0"
        :auto-color="true"
        :dot-scale="1"
        :text="appSrc"
      />
    </van-popup>
  </div>
</template>

<script>
import { doRem } from "../utils/setrem";
import VueQr from "vue-qr";

import qs from "qs";
import { Dialog, Toast } from "vant";
export default {
  mounted() {
    this.chakan();
    // this.getToken()
  },
  data() {
    return {
      hasCard: false,
      noCard: false,
      data: null,
      nowDate: "",
      lastDate: "",
      current: 0,
      num: "",
      appSrc: "",
      codeShow: false,
    };
  },
  components: { VueQr },
  methods: {
    handleKookCodeClick() {
      this.$toast.loading({
        message: "信息获取中...",
        forbidClick: true,
      });
      let params = qs.stringify({ cardType: 6 });
      this.$axios
        .post("/identity/user/otherCert/getQRcode", params)
        .then((res) => {
          console.log(res);
          if (res.data.result !== 1) {
            Toast.clear();
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {});
            return;
          }
          if (res.data.result === 1) {
            Toast.clear();
            this.codeShow = true;
            this.appSrc = res.data.data;
          }
        })
        .catch((err) => {
          Toast.clear();
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
    onChange(index) {
      this.current = index;
    },
    getToken() {
      let token = this.$route.query.token;
      if (!token == "") {
        localStorage.setItem("token", token);
      }
    },
    goView(item) {
      this.$router.push({
        name: "ZhenjianView",
        params: {
          src: item.pdf,
        },
      });
    },

    chakan() {
      this.$toast.loading({
        message: "信息获取中...",
        forbidClick: true,
      });
      var nowDate = new Date();
      var year = nowDate.getFullYear();
      var month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      var day =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      this.nowDate = year + "-" + month + "-" + day;
      this.lastDate = new Date().getFullYear() - 1 + "-" + "01" + "-" + "01";
      let params = qs.stringify({
        cardType: 6,
        keyValueTwo: this.lastDate,
        keyValueThree: this.nowDate,
      });
      this.$axios
        .post("identity/user/elecCertificate/getCertificateInfo", params)
        // .post(
        //   "identity/elecCertificate/getCertificateInfo?keyValue=32058319890121003X&cardType=6&keyValueTwo=2021-01-01&keyValueThree=2022-08-29"
        // )
        .then((res) => {
          if (res.data.result !== 1) {
            Toast.clear();
            Dialog.alert({
              message: "未查询到相关证件信息",
            }).then(() => {});
            return;
          }
          if (res.data.result === 1) {
            Toast.clear();
            this.data = res.data.data;
            this.num = res.data.data.length;
            this.data.forEach((item) => {
              if (JSON.stringify(item) == "{}") {
                this.noCard = true;
              } else {
                this.hasCard = true;
              }
            });
            // if (JSON.stringify(this.data) == "{}") {
            //   this.noCard = true;
            // } else {
            //   this.hasCard = true;
            // }
          }
        })
        .catch((err) => {
          Toast.clear();
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.IDcard {
  background-color: #eef4f6;
  padding: 1.5rem 2rem 0 2rem;
  height: 100vh;
}
.cardPic {
  position: relative;
  background-image: url("../assets/images/canbao.png");
  height: 25rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding-top: 4.25rem;
  padding-left: 3.375rem;
  .zhenjian {
    display: flex;
    align-items: center;

    img {
      width: 5.5rem;
    }
    .word {
      margin-left: 1.625rem;
      line-height: 3rem;
      .zhenjianName {
        color: #ffffff;
        font-size: 2rem;
      }
      .pingzhen {
        color: rgba(255, 255, 255, 0.8);
        font-size: 1.625rem;
      }
    }
  }
  .dibu {
    width: 100%;
    background-image: url("../assets/images/dianziBg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 5.5rem;
    .left {
      position: relative;
    }
    .left::after {
      position: absolute;
      right: 0;
      top: 50%;
      margin-top: -7px;
      content: "";
      height: 14px;
      width: 1px;
      background-color: #fff;
    }
    .left,
    .right {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
    }
    div {
      .word {
        margin-left: 1.25rem;
        font-size: 1.875rem;
        color: #ffffff;
      }
      img {
        width: 3.25rem;
        height: 2.375rem;
      }
    }
  }
}
.my-popup {
  padding: 10px;
}
.shuoming {
  margin-top: 1.25rem;
  background-color: #fff;
  padding: 2.5rem 2rem 1.5rem 2rem;
  border-radius: 1rem;
  .title {
    font-size: 2.125rem;
    color: #19212a;
  }
  .miaosu {
    margin-top: 2.125rem;
    color: #555555;
    font-size: 1.6875rem;
    .miaosuWord {
      margin-top: 1.25rem;
    }
  }
  .fanwei {
    color: #555555;
    font-size: 1.6875rem;
    margin-top: 3.75rem;
    .fanweiWord {
      margin-top: 1.25rem;
      line-height: 3.25rem;
    }
  }
  .changjin {
    color: #555555;
    font-size: 1.6875rem;
    margin-top: 1.25rem;
  }
}
.custom-indicator {
  position: absolute;
  right: 2rem;
  top: 1rem;
  font-size: 1.5rem;
}
</style>